import React from "react";
import { Checkbox, FormControlLabel, Switch, MenuItem, Select, FormControl, InputLabel } from "@material-ui/core";
import {
  getNumberInputValue,
  getNumberOrUndefinedFromString,
} from "../../../../utils/inputUtils";
import InputTextApollo from "../../../inputs/InputTextApollo";
import ProductWidgetContainer from "./ProductWidgetContainer";
import styled from "styled-components/macro";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const ModernExperienceSwitch = styled.div`
  margin-top: 20px;`
const DocumentUnderstandingWidget = ({
  product,
  onRemove,
  onProductChange,
  showDetails,
  clusterProfile,
}: any) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.currentTarget;
    const productCopy = { ...product };
    productCopy.properties = { ...productCopy.properties };
    productCopy.properties[name] = !productCopy.properties[name];
    onProductChange(productCopy);
  };

  const handleVersionChange = (e: React.ChangeEvent<any>) => {
        const {value} = e.target;
        const productCopy: any = {...product};
        productCopy.properties["modelVersion"] = value;
        onProductChange(productCopy);
    };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    if (product?.properties && name) {
      const productCopy = { ...product };
      productCopy.properties = { ...productCopy.properties };
      productCopy.properties[name] = getNumberOrUndefinedFromString(value);
      onProductChange(productCopy);
    }
  };

  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const productCopy = { ...product };
    productCopy.properties = { ...productCopy.properties };
    productCopy.properties.isModernProjectsEnabled = !productCopy.properties.isModernProjectsEnabled;
    onProductChange(productCopy);
  }

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      showDetails={showDetails}
      productProfile={product.profile}
      clusterProfile={clusterProfile}
      onProfileChange={handleProfileChange}
    >
      <FormControlLabel
          control={
            <Checkbox
              checked={!!product.properties.retrainingRequired}
              onChange={handleCheckboxChange}
              name="retrainingRequired"
            />
          }
          label="Retraining Required"
        />

      <FlexSection>
        <div>
          <InputLabel id="model-version-label">Model Version</InputLabel>
          <FormControl fullWidth>
            <Select
              label="Model Version"
              labelId="model-version-label"
              value={product.properties.modelVersion || "22.10"}
              onChange={handleVersionChange}
            >   
              <MenuItem key={"22.10"} value={"22.10"}>22.10</MenuItem>
              <MenuItem key={"23.4"} value={"23.4"}>23.4</MenuItem>
              <MenuItem key={"23.7"} value={"23.7"}>23.7</MenuItem>
              <MenuItem key={"23.10"} value={"23.10"}>23.10</MenuItem>
            </Select>
          </FormControl>
        </div>
      </FlexSection>

      <FlexSection>
        <InputTextApollo
          label="General Extractor (pages per hour)"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "generalExtractorPerHour",
            value: getNumberInputValue(product.properties.generalExtractorPerHour),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="Invoices (pages per hour)"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "invoicesPerHour",
            value: getNumberInputValue(product.properties.invoicesPerHour),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="Receipts (pages per hour)"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "receiptsPerHour",
            value: getNumberInputValue(product.properties.receiptsPerHour),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="Purchase Orders (pages per hour)"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "purchaseOrdersPerHour",
            value: getNumberInputValue(product.properties.purchaseOrdersPerHour),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="Utility Bills (pages per hour)"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "utilityBillsPerHour",
            value: getNumberInputValue(product.properties.utilityBillsPerHour),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="OCR (pages per hour)"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "ocrPerHour",
            value: getNumberInputValue(product.properties.ocrPerHour),
            onChange: handleInputChange,
          }}
        />
        <InputTextApollo
          label="Intelligent Form Extractor (handwriting shreds per hour)"
          variant="outlined"
          inputProps={{ type: "number" }}
          InputProps={{
            name: "shredsPerHour",
            value: getNumberInputValue(product.properties.shredsPerHour),
            onChange: handleInputChange,
          }}
        />
      </FlexSection>
      <ModernExperienceSwitch>
        <FormControlLabel
          control={
            <Switch
              checked={!!product.properties.isModernProjectsEnabled}
              onChange={handleToggle}
              />
          }
          label={"Document Understanding modern projects"}
        />
      </ModernExperienceSwitch>
      {!!product.properties.isModernProjectsEnabled && <>
        <FlexSection>
          <InputTextApollo
              label="Custom Model Pages per Hour"
              variant="outlined"
              inputProps={{ type: "number" }}
              InputProps={{
                name: "customModelPagesPerHour",
                value: getNumberInputValue(product.properties.customModelPagesPerHour),
                onChange: handleInputChange,
              }}
            />
          <InputTextApollo
              label="OOB Model Pages per Hour"
              variant="outlined"
              inputProps={{ type: "number" }}
              InputProps={{
                name: "oobModelPagesPerHour",
                value: getNumberInputValue(product.properties.oobModelPagesPerHour),
                onChange: handleInputChange,
              }}
            />
          <InputTextApollo
              label="Models Training in Parallel"
              variant="outlined"
              inputProps={{ type: "number", min: 1 }}
              InputProps={{
                name: "modelsTrainingInParallel",
                value: getNumberInputValue(product.properties.modelsTrainingInParallel),
                onChange: handleInputChange,
              }}
            />
        </FlexSection>
      </>
      }

    </ProductWidgetContainer>
  );
};

export default DocumentUnderstandingWidget;
